/**
 * DAGPanel — provenance graph visualisation.
 *
 * Renders the provenance DAG using React Flow + ELK layout.
 * Shows how every variable flows from import to plot.
 */

import { Box } from "@radix-ui/themes";
import { ReactFlowProvider } from "@xyflow/react";
import { DAGView } from "../dag/DAGView";

interface Props {
  projectId: string;
}

export default function DAGPanel({ projectId }: Props) {
  return (
    <ReactFlowProvider>
      <Box style={{ height: "100%" }}>
        <DAGView projectId={projectId} />
      </Box>
    </ReactFlowProvider>
  );
}
